<template>
  <div class="org-initials-circle" v-if="orgInitials">
    <span>{{ orgInitials }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useUserStore } from "@/stores/user";
import { useOrganizationStore } from "@/stores/organization";

const userStore = useUserStore();
const organizationStore = useOrganizationStore();

const currentOrg = computed(() => {
  return organizationStore.allDict[userStore.activeOrganization];
});

const currentOrgName = computed(() => {
  return currentOrg.value?.name ?? "";
});


const orgInitials = computed(() => {
  if (!currentOrgName.value) return "N/A";

  const words = currentOrgName.value.split(/\s+/);

  let initials = words
    .map((word) => {
      const match = word.match(/[a-zA-Z]/);
      return match ? match[0].toUpperCase() : "";
    })
    .join("");

  if (initials.length === 1 && words[0].length > 1) {
    initials += words[0][1].toUpperCase();
  }

  return initials.slice(0, 2) || "N/A"; 
});


</script>

<style scoped lang="scss">
.org-initials-circle {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 1px solid $neutral-300;

  display: flex;
  align-items: center;
  justify-content: center;

  color: $neutral-300;
  font-weight: 600; 
  font-size: 0.8rem; 
}
</style>
